export default __webpack_public_path__ + "static/hero-4228fe70bc5331da875c793029e71d99.jpg";